export default "__VITE_ASSET__aQTNYWtc__"